<nav class="public-header navbar navbar-expand-lg navbar-light fixed-top">
  <img src="../../../../assets/img/logo/logo.png" alt="{{ configService.ownerNicename }}" height="30">
</nav> <!-- /.navbar -->

<div class="page">
  <div class="page-content">
    <div>
      <div class="row main-row" *ngIf="formUserData">
        <div class="col-12 col-md-8 col-lg-5 p-5 d-flex align-items-center justify-content-center left-col">
          <div class="col-content">
            <h1 class="h2">{{ 'qrcode.page.h1' | translate }}</h1>
            <p class="lead" *ngIf="isVideo">{{ 'qrcode.page.leadVideo' | translate }}</p>
            <p class="lead" *ngIf="isDoc">{{ 'qrcode.page.leadDoc' | translate }}</p>
            <p class="lead" *ngIf="isDocsSection">{{ 'qrcode.page.leadDocSection' | translate }}</p>
            <div class="form-wrapper mt-3">
              <form [formGroup]="form" (ngSubmit)="onFormSubmit(model)">
                <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
                <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate">
                </mat-spinner-button>
              </form>
            </div> <!-- /.form-wrapper -->
          </div> <!-- /.col-content -->
        </div> <!-- /.col -->
      </div> <!-- /.row -->

      <div class="row main-row mt-5" id="doc-wrapper" *ngIf="isFireSafetyDoc && fireSafetyDoc">
        <ng-container>
          <table class="table table-borderless">
            <tbody>
              <tr>
                <td>
                  {{ fireSafetyDoc?.name }}
                </td>
              </tr>
              <tr>
                <td>
                  {{ fireSafetyDoc?.description }}
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
        <ng-container>
          <div class="document-wrapper">
            <table class="table table-borderless table-striped table-hover">
              <thead>
                <th>
                  {{ 'companies.fields.fireSafetyDocs.file' | translate }}</th>
              </thead>
              <tbody>
                <tr *ngFor="let item of fireSafetyDoc?.files">
                  <td>
                    <a href="{{ configService.apiHost }}/{{ item.path }}" target="_blank" matTooltip="{{ 'common.cta.open_new_tab' | translate }}">
                      {{ item.originalName }} 
                      <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action">
                      </mat-icon>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>
      <div class="row main-row mt-5" id="doc-wrapper" *ngIf="isFireSafetyDoc && !fireSafetyDoc">
        <ng-container>
          <div class="document-wrapper">
            <strong class="doc-missing">{{ 'common.errors.noLongerAvailable' | translate }}</strong>
          </div>
        </ng-container>
      </div>


      <div class="row main-row mt-5" id="doc-wrapper" *ngIf="isGenericDoc && genericDoc">
        <ng-container>
          <table class="table table-borderless">
            <tbody>
              <tr>
                <td>
                  {{ genericDoc?.name }}
                </td>
              </tr>
              <tr>
                <td>
                  {{ genericDoc?.description }}
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
        <ng-container>
          <div class="document-wrapper">
            <table class="table table-borderless table-striped table-hover">
              <thead>
                <th>
                  {{ 'genericDocs.fields.file' | translate }}</th>
              </thead>
              <tbody>
                <tr *ngFor="let item of genericDoc?.files">
                  <td>
                    <a href="{{ configService.apiHost }}/{{ item.path }}" target="_blank" matTooltip="{{ 'common.cta.open_new_tab' | translate }}">
                      {{ item.originalName }} 
                      <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action">
                      </mat-icon>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>
      <div class="row main-row mt-5" id="doc-wrapper" *ngIf="isGenericDoc && !genericDoc">
        <ng-container>
          <div class="document-wrapper">
            <strong class="doc-missing">{{ 'common.errors.noLongerAvailable' | translate }}</strong>
          </div>
        </ng-container>
      </div>

      <div class="row main-row mt-5" id="doc-wrapper" *ngIf="isPrivacyStudioDoc && privacyStudioDoc">
        <ng-container>
          <table class="table table-borderless">
            <tbody>
              <tr>
                <td>
                  {{ 'companies.fields.privacyStudioDocs.types.' + privacyStudioDoc?.type | translate }}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>{{ 'companies.fields.privacyStudioDocs.description' | translate }}:</strong>
                  {{ privacyStudioDoc?.description }}
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
        <ng-container>
          <div class="document-wrapper">
            <table class="table table-borderless table-striped table-hover">
              <thead>
                <th>
                  {{ 'companies.fields.privacyStudioDocs.file' | translate }}</th>
              </thead>
              <tbody>
                <tr *ngFor="let item of privacyStudioDoc?.files">
                  <td>
                    <a href="{{ configService.apiHost }}/{{ item.path }}" target="_blank" matTooltip="{{ 'common.cta.open_new_tab' | translate }}">
                      {{ item.originalName }}
                      <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action">
                      </mat-icon>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>
      <div class="row main-row mt-5" id="doc-wrapper" *ngIf="isPrivacyStudioDoc && !privacyStudioDoc">
        <ng-container>
          <div class="document-wrapper">
            <strong class="doc-missing">{{ 'common.errors.noLongerAvailable' | translate }}</strong>
          </div>
        </ng-container>
      </div>

      <div class="row main-row" *ngIf="showVideo || showVideoSupplier">
        <div class="col-12 p-5 align-items-center justify-content-center">
          <video id="idVideo" preload="auto" controls autoplay width="100%" height="auto">
            <source src="assets/video/Archedi-SD3.mp4" type="video/mp4">
            <source src="assets/video/Archedi-SD3.webm" type="video/webm">
            <source src="assets/video/Archedi-SD3.ogv" type="video/ogg">
          </video>
        </div>
      </div>
      <div class="row main-row" *ngIf="showVideoResident">
        <div class="col-12 mt-5 text-center" *ngIf="showMasterVideoResident">
          {{ master }}
        </div>
        <div class="col-12 mt-2 text-center" *ngIf="showMasterVideoResident">
          ASSOCIATO <img src="../../../../assets/img/anaci-logo.png" alt="ANACI" height="45">
        </div>
        <div class="col-12 p-5 align-items-center justify-content-center">
          <video id="idVideo" preload="auto" controls autoplay width="100%" height="auto">
            <source src="assets/video/Archedi-Resident.mp4" type="video/mp4">
            <source src="assets/video/Archedi-Resident.webm" type="video/webm">
            <source src="assets/video/Archedi-Resident.ogv" type="video/ogg">
          </video>
        </div>
      </div>

      <!-- List of all documents -->
      <div class="row main-row mt-5" id="doc-wrapper" *ngIf="showDocSection || showDoc">
        <ng-container *ngFor="let item of displayedDocs | keyvalue: originalOrder; let i = index">
          <div class="document-wrapper">
            <div class="document-wrapper title">
              {{ i + 1 }} {{ item.value.title?.toUpperCase() }}
            </div>
            <div *ngIf="item.value.type === 'title'">
              <div *ngFor="let docItem of item.value.content | keyvalue: originalOrder; let t = index">
                <div class="d-flex document-wrapper subtitle" id="{{ docItem.value.title }}" #scrollTarget>
                  <div>
                    {{ i + 1 }}.{{ t + 1 }} {{ docItem.value.title }}
                  </div>
                </div>
                <div *ngIf="docItem.value.type === 'title'">
                  <div *ngFor="let subDocItem of docItem.value.content | keyvalue: originalOrder; let x = index">
                    <div class="document-wrapper subsubtitle">
                      <div *ngIf="!subDocItem.value.active" class="structure-deleted">
                        {{ i + 1 }}.{{ t + 1 }}.{{ x + 1 }} {{ subDocItem.value.title }}
                        {{ 'properties.documentsPage.sctructureDeleted' | translate }}
                      </div>
                      <div *ngIf="subDocItem.value.active" id="{{ subDocItem.value.title }}" #scrollTarget>
                        {{ i + 1 }}.{{ t + 1 }}.{{ x + 1 }} {{ subDocItem.value.title }}
                      </div>
                    </div>
                    <div *ngIf="subDocItem.value.content.length">
                      <table class="table table-borderless table-striped table-hover" matSort
                        (matSortChange)="sortData($event, i, t, x, '1')">
                        <thead>
                          <th class="clickable col-fixed-md" mat-sort-header="title">
                            {{ 'properties.documentsPage.docType' | translate }}</th>
                          <th class="col-fixed-xxs text-center">Azioni</th>

                        </thead>
                        <tbody>
                          <tr *ngFor="let subSubDocItem of subDocItem.value.content | keyvalue: originalOrder"
                            [ngClass]="{'document-wrapper-text-mandatory-added': subSubDocItem.value.mandatory && !subSubDocItem.value.expired && helperService.isDocumentDataPopulated(subSubDocItem.value.data),
                              'document-wrapper-text-mandatory-missing': subSubDocItem.value.mandatory && !subSubDocItem.value.expired && !helperService.isDocumentDataPopulated(subSubDocItem.value.data),
                              'document-wrapper-text-not-mandatory': !subSubDocItem.value.mandatory || subSubDocItem.value.expired}">
                            <!-- TIPO -->
                            <td class="col-fixed-md document-wrapper-text">
                              {{ subSubDocItem.value.title }}
                              <div *ngIf="subSubDocItem.value.expired" class="document-expired">
                                {{ (subSubDocItem.value.privacy ? 'properties.documentsPage.tagSuperato' : 'properties.documentsPage.tagExpired') | translate }}</div>
                            </td>
                            <!-- AZIONI -->
                            <td class="row-archive">
                              <!--
                              <div *ngIf="item.value.keyTranslateTitle=='properties.documents.unitaImmobiliari'">
                                <button mat-icon-button
                                  *ngIf="subSubDocItem.value.data && subDocItem.value.active"
                                  (click)="onToggleEditShowDocument(subSubDocItem.value.title, subSubDocItem.value.key, subDocItem.value.docId, subSubDocItem.value.docId, subSubDocItem.value.data, 'show', '', subSubDocItem.value.keyTranslateTitle, subDocItem.value.structureId, subSubDocItem.value.expired, subSubDocItem.value.pdfmsg)">
                                  <mat-icon fontSet="fal" fontIcon="fa-search" class="icon-action"></mat-icon>
                                </button>
                              </div>
                               -->
                              <div *ngIf="item.value.keyTranslateTitle!='properties.documents.unitaImmobiliari'"
                                style="padding-left: 30%;">
                                <!-- 
                                <button mat-icon-button
                                  *ngIf="subSubDocItem.value.data && subDocItem.value.active"
                                  (click)="onToggleEditShowDocument(subSubDocItem.value.title, subSubDocItem.value.key, subDocItem.value.docId, subSubDocItem.value.docId, subSubDocItem.value.data, 'show', '', docItem.value.keyTranslateTitle, subDocItem.value.structureId, subSubDocItem.value.expired, subSubDocItem.value.pdfmsg)">
                                  <mat-icon fontSet="fal" fontIcon="fa-search" class="icon-action"></mat-icon>
                                </button>
                                -->

                                <button mat-icon-button *ngIf="subSubDocItem.value.data 
                                  && subSubDocItem.value.data.document
                                  && subSubDocItem.value.data.document.length"
                                  (click)="onToggleDownloadDocument(subSubDocItem.value.data.document)">
                                  <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action">
                                  </mat-icon>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div *ngIf="docItem.value.type === 'contract'">
                  <div *ngFor="let subDocItem of docItem.value.content | keyvalue: originalOrder; let x = index">

                    <div *ngIf="subDocItem.value.content.length" id="{{ subDocItem.value.title }}" #scrollTarget>

                      <table class="table table-borderless table-striped table-hover" matSort
                        (matSortChange)="sortData($event, i, t, x, '1')">
                        <thead>
                          <th class="clickable col-fixed-md" mat-sort-header="title">
                            {{ 'properties.documentsPage.docType' | translate }}</th>
                          <th class="col-fixed-xxs text-center">Azioni</th>

                        </thead>
                        <tbody>
                          <tr *ngFor="let subSubDocItem of subDocItem.value.content | keyvalue: originalOrder"
                            [ngClass]="{'document-wrapper-text-mandatory-added': subSubDocItem.value.mandatory && !subSubDocItem.value.expired && helperService.isDocumentDataPopulated(subSubDocItem.value.data),
                              'document-wrapper-text-mandatory-missing': subSubDocItem.value.mandatory && !subSubDocItem.value.expired && !helperService.isDocumentDataPopulated(subSubDocItem.value.data),
                              'document-wrapper-text-not-mandatory': !subSubDocItem.value.mandatory || subSubDocItem.value.expired}">
                            <!-- TIPO -->
                            <td class="col-fixed-md document-wrapper-text">
                              {{ subSubDocItem.value.title }}
                              <strong *ngIf="subSubDocItem.value.structureTitle !=''">({{
                                subSubDocItem.value.structureTitle }})</strong>
                              <div *ngIf="subSubDocItem.value.expired" class="document-expired">
                                {{ (subSubDocItem.value.privacy ? 'properties.documentsPage.tagSuperato' : 'properties.documentsPage.tagExpired') | translate }}</div>
                            </td>
                            <!-- AZIONI -->
                            <td class="row-archive" style="padding-left: 30%;">
                              <!-- 
                              <button mat-icon-button
                                *ngIf="subSubDocItem.value.data && subSubDocItem.value.active"
                                (click)="onToggleEditShowDocument(subSubDocItem.value.title, subSubDocItem.value.key, subSubDocItem.value.documentId, subSubDocItem.value.docId, subSubDocItem.value.data, 'show', '', subSubDocItem.value.keyTranslateTitle, subSubDocItem.value.structureId, subSubDocItem.value.expired, subSubDocItem.value.pdfmsg)">
                                <mat-icon fontSet="fal" fontIcon="fa-search" class="icon-action"></mat-icon>
                              </button>
                               -->

                              <button mat-icon-button *ngIf="subSubDocItem.value.data 
                                && subSubDocItem.value.data.document
                                && subSubDocItem.value.data.document.length"
                                (click)="onToggleDownloadDocument(subSubDocItem.value.data.document)">
                                <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action">
                                </mat-icon>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div *ngIf="docItem.value.type === 'doc'">
                  <table class="table table-borderless table-striped table-hover" matSort
                    (matSortChange)="sortData($event, i, t, '', '2')">
                    <thead>
                      <th class="clickable col-fixed-md" mat-sort-header="title">
                        {{ 'properties.documentsPage.docType' | translate }}</th>
                      <th class="col-fixed-xxs text-center">Azioni</th>
                    </thead>
                    <tbody>
                      <tr *ngFor="let subDocItem of docItem.value.content | keyvalue: originalOrder"
                        [ngClass]="{'document-wrapper-text-mandatory-added': subDocItem.value.mandatory && !subDocItem.value.expired && helperService.isDocumentDataPopulated(subDocItem.value.data),
                              'document-wrapper-text-mandatory-missing': subDocItem.value.mandatory && !subDocItem.value.expired && !helperService.isDocumentDataPopulated(subDocItem.value.data),
                              'document-wrapper-text-not-mandatory': !subDocItem.value.mandatory || subDocItem.value.expired}">
                        <td class="col-fixed-md document-wrapper-text">
                          {{ subDocItem.value.title }}
                          <div *ngIf="subDocItem.value.expired" class="document-expired">
                            {{ (subDocItem.value.privacy ? 'properties.documentsPage.tagSuperato' : 'properties.documentsPage.tagExpired') | translate }}</div>
                        </td>
                        <td class="row-archive" style="padding-left: 30%;">
                          <!-- 
                          <button mat-icon-button *ngIf="subDocItem.value.data"
                            (click)="onToggleEditShowDocument(subDocItem.value.title, subDocItem.value.key, docItem.value.docId, subDocItem.value.docId, subDocItem.value.data, 'show', '', docItem.value.keyTranslateTitle, subDocItem.value.structureId, subDocItem.value.expired, subDocItem.value.pdfmsg)">
                            <mat-icon fontSet="fal" fontIcon="fa-search" class="icon-action"></mat-icon>
                          </button>
                           -->

                          <button mat-icon-button *ngIf="subDocItem.value.data
                            && subDocItem.value.data.document
                            && subDocItem.value.data.document.length"
                            (click)="onToggleDownloadDocument(subDocItem.value.data.document)">
                            <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action"></mat-icon>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div *ngIf="item.value.type === 'doc'">
              <table class="table table-borderless table-striped table-hover" matSort
                (matSortChange)="sortData($event, i, '', '', '3')">
                <thead>
                  <th class="clickable col-fixed-md" mat-sort-header="title">
                    {{ 'properties.documentsPage.docType' | translate }}</th>
                  <th class="col-fixed-xxs text-center">Azioni</th>
                </thead>
                <tbody>
                  <tr *ngFor="let subDocItem of item.value.content | keyvalue: originalOrder"
                    [ngClass]="{'document-wrapper-text-mandatory-added': subDocItem.value.mandatory && !subDocItem.value.expired && helperService.isDocumentDataPopulated(subDocItem.value.data),
                              'document-wrapper-text-mandatory-missing': subDocItem.value.mandatory && !subDocItem.value.expired && !helperService.isDocumentDataPopulated(subDocItem.value.data),
                              'document-wrapper-text-not-mandatory': !subDocItem.value.mandatory || subDocItem.value.expired}">
                    <td class="col-fixed-md">
                      {{ subDocItem.value.title }}
                      <div *ngIf="subDocItem.value.expired" class="document-expired">
                        {{ (subDocItem.value.privacy ? 'properties.documentsPage.tagSuperato' : 'properties.documentsPage.tagExpired') | translate }}</div>
                    </td>
                    <td class="row-archive" style="padding-left: 30%;">
                      <!-- 
                      <button mat-icon-button *ngIf="subDocItem.value.data"
                        (click)="onToggleEditShowDocument(subDocItem.value.title, subDocItem.value.key, item.value.docId, subDocItem.value.docId, subDocItem.value.data, 'show', '', docItem.value.keyTranslateTitle, subDocItem.value.structureId, subDocItem.value.expired, subDocItem.value.pdfmsg)">
                        <mat-icon fontSet="fal" fontIcon="fa-search" class="icon-action"></mat-icon>
                      </button>
                       -->

                      <button mat-icon-button *ngIf="subDocItem.value.data 
                        && subDocItem.value.data.document
                        && subDocItem.value.data.document.length"
                        (click)="onToggleDownloadDocument(subDocItem.value.data.document)">
                        <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action"></mat-icon>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>
      </div>
      <!-- /List of all documents -->

    </div> <!-- /.container -->
  </div> <!-- /.page-content -->
</div> <!-- /.page -->